import type {
  vehicles,
  Improvement,
  Incentive,
  OfferStatus,
  DealStatus,
} from '@prisma/client';
import api from '../api';

/** Anonymized competing offer — no dealer identity, no VIN. */
export interface CompetingOffer {
  price: number | null;
  improvements: Improvement[];
  incentives: Incentive[];
  year: number;
  mileage: number;
  trim: string;
  listPrice: number | null;
}

export interface DealerOfferView {
  id: string;
  dealer: string;
  status: OfferStatus;
  price: number | null;
  improvements: Improvement[];
  incentives: Incentive[];
  submittedAt: string | null;
  vehicle: vehicles;
  deal: {
    id: string;
    status: DealStatus;
    initialWindowEnd: string;
    offerExpDate: string;
    canSubmit: boolean;
  };
  competition: {
    total: number;
    priced: number;
    revealed: boolean;
    offers: CompetingOffer[];
  };
  buyer?: {
    firstName: string;
    lastName: string;
    email: string | null;
    phone: string | null;
  };
}

export interface DealerOfferSubmission {
  price: number;
  improvements: Improvement[];
  incentives: Incentive[];
}

const dealerOffersService = {
  get: async (token: string): Promise<DealerOfferView> => {
    const response = await api.get<DealerOfferView>(`/dealer-offers/${token}`);
    return response.data;
  },
  submit: async (
    token: string,
    data: DealerOfferSubmission
  ): Promise<DealerOfferView> => {
    const response = await api.patch<DealerOfferView>(
      `/dealer-offers/${token}`,
      data
    );
    return response.data;
  },
};

export default dealerOffersService;
